import React from 'react'
import { StyleProp, StyleSheet, TextStyle, View, ViewProps } from 'react-native'

import { Icon } from '../../component/icon'
import { Color, Spacing } from '../../style'

import { TableSortDirection } from './table'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: Spacing.XS,
  },
  icon: {
    color: Color.calmGrey,
  },
  active: {
    color: Color.premiumBlack,
  },
})

interface Props extends ViewProps {
  direction?: TableSortDirection
  iconStyle?: StyleProp<TextStyle>
  activeStyle?: StyleProp<TextStyle>
}
const Sort = (props: Props) => {
  const { direction, iconStyle, activeStyle, style, ...otherProps } = props

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Icon
        name="up"
        style={[styles.icon, iconStyle, direction === 'desc' && styles.active, direction === 'desc' && activeStyle]}
        size="XS"
      />
      <Icon
        name="down"
        style={[styles.icon, iconStyle, direction === 'asc' && styles.active, direction === 'asc' && activeStyle]}
        size="XS"
      />
    </View>
  )
}

export default Sort
